import { Component, OnInit, Inject, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { CoreLanguageService } from "../../services/language.service";
import * as _ from "lodash";
import { MenuChangeLocationViewModel } from "../../shared/models/location.model";
import { WebShopMode } from "../../services/IWebShopService";
import { Router } from "@angular/router";
import { LocationService } from "../../components/location/location.service";
import { CoreLogService } from "../../services/log.service";

@Component({
  selector: "app-menuchangelocationdialog",
  templateUrl: "./menuChangeLocationDialog.component.html",
  styleUrls: ["./menuChangeLocationDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuChangeLocationDialogComponent implements OnInit {

  public menuChangeLocationViewModel: MenuChangeLocationViewModel = new MenuChangeLocationViewModel();
  public distance: string = null;
  public serviceOpenTimeTitle = "";

  constructor(public bottomSheetRef: MatBottomSheetRef<MenuChangeLocationDialogComponent>
    , private _coreLanguageService: CoreLanguageService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _router: Router
    , private _locationService: LocationService
    , @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("MenuChangeLocationDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.setOpenTimeTitle();
    me.GetLocationData();
  }

  private setOpenTimeTitle() {
    const me = this;
    switch (me.data.serviceID) {
      case WebShopMode.Delivery:
        {
          me.serviceOpenTimeTitle = "phGlobal_Delivery_openTime";
          break;
        }
      case WebShopMode.TakeAway:
        {
          me.serviceOpenTimeTitle = "phGlobal_Pickup_openTime";
          break;
        }
      default: {
        me.serviceOpenTimeTitle = "phGlobal_OpenTime";
        break;
      }
    }
    me.PushChanges();
  }

  public GetLocationData() {
    const me = this;
    if (me.data.locationID) {
      me._locationService.GetMenuChangeLocation(me.data.locationID, me.data.serviceID)
        .then(locationViewModel => {
          me.menuChangeLocationViewModel = locationViewModel;
          me.PushChanges();
        })
        .catch(e => {
          me._coreLogService.error("MenuChangeLocationDialogComponent.GetLocationData", "GetMenuChangeLocation", e);
        });
    }
  }

  public OpenWebVoucherModal() {
    const me = this;
    // true to open another modal after closing this one
    me.bottomSheetRef.dismiss(true);
  }

  public getLocationText(): string {
    const me = this;
    return _.escape(me._coreLanguageService.value("phMenuChangeLocationDialog_YouAreInLocation_BASE")).replace("{location}", `<b>${me.menuChangeLocationViewModel.label}</b>`);
  }

  public getDistanceText(): string {
    const me = this;
    return _.escape(me._coreLanguageService.value("phMenuChangeLocationDialog_YouAreKmAway_BASE")).replace("{distance}", `<b>${me.distance}</b>`);
  }

  public onChangeLocation() {
    const me = this;
    me._router.navigate(["/menulocation"]);
    me.bottomSheetRef.dismiss();
  }

  public onChangeService() {
    const me = this;
    me._router.navigate(["/menuservice"]);
    me.bottomSheetRef.dismiss();
  }
}
